import React from 'react'
import { authRoles } from '../../../auth/authRoles'

const  adminPlanoRoutes = [
    {
        path: '/admin/plano',
        component: React.lazy(() => import('./AdminPlanoList')),
        auth: authRoles.admin,
    },
    {
        path: '/admin/plano_form/:action/:id?',
        component: React.lazy(() => import('./AdminPlanoForm')),
        auth: authRoles.admin,
    }
]

export default adminPlanoRoutes
